import React, { useContext, useState, memo } from 'react';
import { AdvancedSearchV2Context } from './AdvancedSearchV2Context';
import LocationFilterModal from '../LocationFilterModal';

const AdvancedSearchV2LocationFilter = ({ resetFilters }) => {
  const [state, dispatch] = useContext(AdvancedSearchV2Context);
  const toggle = (value) => dispatch({ filterList: 'location', value });
  const [locationLabel, setLocationLabel] = useState('-');
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="company-score vertical-expertise search-filter">
      <label>Location</label>
      <div className="selected" onClick={() => setShowModal(!showModal)}>
        <p>{locationLabel}</p>
      </div>
      <LocationFilterModal
        showModal={showModal}
        setShowModal={setShowModal}
        filters={state.siteFilters.location}
        toggle={toggle}
        filterLabel="Location"
        setLocationLabel={setLocationLabel}
        resetFilters={resetFilters}
      />
    </div>
  );
};

export default memo(AdvancedSearchV2LocationFilter);
